export enum CustomHTTPHeaders {
  X_CLIENT_SOURCE = 'X-Client-Source',
  X_CLIENT_SOURCE_PATH = 'X-Client-Source-Path',
  X_ORGANIZATION_ID = 'X-Organization-Id',
}

export enum ClientSourcePathHeaderOptions {
  PROMPT_EXPLORER = 'prompt-explorer',
  DOC_CHAT = 'doc-chat',
  PLAYGROUND = 'playground',
  BUILDER = 'builder',
  SHARED_PROTOTYPES = 'shared-prototypes',
}
